// extracted by mini-css-extract-plugin
export default {"notification":"Synchronize_notification__E50kn","icon":"Synchronize_icon__jPUNu","text":"Synchronize_text__dkuxE","button":"Synchronize_button__JwJE-"};